import { defineComponent, computed, openBlock, createElementBlock, normalizeStyle, createCommentVNode, renderSlot } from "vue";
import { u as useComponentPresetProp } from "../../composables/useComponentPreset.js";
import { u as useNumericProp } from "../../composables/useNumericProp.js";
const _sfc_main = /* @__PURE__ */ defineComponent({
  ...{
    name: "VaAspectRatio"
  },
  __name: "VaAspectRatio",
  props: {
    ...useComponentPresetProp,
    ratio: {
      type: [Number, String],
      default: "auto"
    },
    contentHeight: { type: [Number, String], default: 1 },
    contentWidth: { type: [Number, String], default: 1 },
    maxWidth: {
      type: [Number, String],
      default: 0,
      validator: (v) => Number(v) >= 0
    }
  },
  setup(__props) {
    const props = __props;
    const contentHeightComputed = useNumericProp("contentHeight");
    const contentWidthComputed = useNumericProp("contentWidth");
    const aspectRatio = computed(() => {
      if (props.ratio === "auto" && props.contentHeight === 1 && props.contentWidth === 1) {
        return 0;
      }
      if (!isNaN(+props.ratio)) {
        return props.ratio;
      }
      return contentWidthComputed.value / contentHeightComputed.value;
    });
    const stylesComputed = computed(() => {
      if (!aspectRatio.value) {
        return;
      }
      return { paddingBottom: `${1 / aspectRatio.value * 100}%` };
    });
    const maxWidthComputed = computed(() => props.maxWidth ? `${props.maxWidth}px` : void 0);
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: "va-aspect-ratio",
        style: normalizeStyle(`--va-max-width-computed: ${String(maxWidthComputed.value)}`)
      }, [
        stylesComputed.value ? (openBlock(), createElementBlock("div", {
          key: 0,
          style: normalizeStyle(stylesComputed.value)
        }, null, 4)) : createCommentVNode("", true),
        renderSlot(_ctx.$slots, "default")
      ], 4);
    };
  }
});
export {
  _sfc_main as _
};

import '../../../VaAspectRatio.css';
//# sourceMappingURL=VaAspectRatio.vue_vue_type_script_setup_true_lang.js.map
